/** Drops null / undefined / "" keys — query params the backend shouldn't see. */
export const cleanObject = (obj) => {
  const result = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value !== null && value !== undefined && value !== '') {
      result[key] = value;
    }
  });
  return result;
};
